<script>
import CustomButton from '@/components(new)/UI/Buttons/CustomButton/CustomButton.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import '@/scss/_utilities.scss'

export default {
  mixins: [
    AppNotificacao
  ],
  components: {
    CustomButton
  },
  props: {
    label: {
      typeof: String,
      required: false
    },
    pageBack: {
      typeof: String,
      required: false,
      default: null
    },
    hasProcesso: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    voltar () {
      this.confirmBox('Você tem certeza que deseja voltar? Todos os dados não salvos serão perdidos.', this.$messages.TITULO_WARNING,
        () => {
          this.pageBack ? this.$router.push({name: this.pageBack}) : this.$router.back()
        },
        () => {
        }, 'Sim', 'Não')
    }
  }
}
</script>

<template>
  <div class="flex-aligned">
    <CustomButton icon="el-icon-arrow-left" StyleSheet="padding: 0.2rem 0.7rem" @click="voltar()" />
    <h3 class="m-1"> {{ hasProcesso ? 'Editar Cadastro' : label }} </h3>
    <slot></slot>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/HeaderVoltar/HeaderVoltar.vue